module.exports = __webpack_public_path__ + "static/media/19.145adc38.png";